import { Panel, Flex, Typography, Button } from '@maxhub/max-ui';

interface ConsentPageProps {
  onBack: () => void;
}

export function ConsentPage({ onBack }: ConsentPageProps) {
  return (
    <Panel style={{ minHeight: '100vh', padding: '1rem' }}>
      <Button mode="link" onClick={onBack} style={{ marginBottom: '1rem' }}>
        ← Назад
      </Button>

      <Typography.Headline
        variant="medium-strong"
        style={{ display: 'block', marginBottom: '1rem' }}
      >
        Согласие на обработку персональных данных
      </Typography.Headline>

      <Flex direction="column" gap={12}>
        <Typography.Label style={{ display: 'block', lineHeight: '1.6' }}>
          Регистрируясь в мини-приложении «Водомерка», я, в соответствии с Федеральным законом
          от 27.07.2006 № 152-ФЗ «О персональных данных», даю своё согласие ТСН «Рокада» на
          обработку (сбор, хранение, использование) следующих персональных данных: фамилия,
          имя, отчество, номер телефона, номер дома/корпуса, показания приборов учёта воды.
        </Typography.Label>
        <Typography.Label style={{ display: 'block', lineHeight: '1.6' }}>
          Цель обработки — учёт показаний счётчиков воды и формирование платёжных квитанций
          собственникам и совладельцам жилых помещений ТСН «Рокада».
        </Typography.Label>
        <Typography.Label style={{ display: 'block', lineHeight: '1.6' }}>
          Персональные данные обрабатываются в течение всего срока пользования приложением.
          Согласие может быть отозвано в любой момент по обращению к администрации ТСН
          «Рокада» — в этом случае доступ к приложению будет прекращён.
        </Typography.Label>
      </Flex>
    </Panel>
  );
}
